import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { getRequest, postRequest, patchRequest, deleteRequest } from '@/plugins/api-axios'
import JsonApiObject from '@/_models/JsonApiObject'
import { deserialise, serialise } from 'kitsu-core'
import { getURL } from '@/utils/axios'

@Mixin
export default class ProjectMixin extends Vue {
    url_project = process.env.VUE_APP_PROJECT_BASE_URL
    contractorBaseUrl = process.env.VUE_APP_CONTRACTOR_BASE_URL
    formBaseUrl = process.env.VUE_APP_FORM_BASE_URL
    languageBaseUrl = process.env.VUE_APP_TRANSLATION_BASE_URL
    url_authorization = process.env.VUE_APP_AUTHORIZATION_BASE_URL

    projectSettingsFields =
        'fields[project]=id,customId,bklrId,name,timeZone,description,avatarFileId,address,currency,emergencyNumber,agreementUrl,itbaseUrl,customerReference,orderReference,invoiceRecipient,hseBoardDescription,publicHseBoardDescription,isDeleted,deletedAt,permissions,contractorPermissions,hasHseContacts,canCreateBklrProject,createdAt,updatedAt,constraints,owner,modules'

    get headersmixins() {
        return {
            'Content-Type': 'application/vnd.api+json',
        }
    }

    getGroupPermissions(group: any) {
        let permissions: Array<any> = []
        group.relationships.projects.data.map((project: any) => {
            permissions = [
                ...permissions,
                ...this.$store.getters.project(project.id).attributes.permissions,
            ]
        })
        return permissions
    }

    projectLocations(id: string) {
        return this.$store.getters.locations.filter((location: any) => {
            return location.relationships.project.data?.id == id
        })
    }

    filterProjectByAccessibleModules(projects: Array<any>, name: string) {
        let res = projects
            ? projects.filter((project: any) => {
                  return this.$store.getters.projectAccessibleModules(project.id)
                      ? this.$store.getters.projectAccessibleModules(project.id)[name]
                      : false
              })
            : projects

        return res
    }

    // PROJECT
    async getProjects(params: any) {
        let url = `${this.url_project}/projects?include=userSettings,owner`
        let res = await getRequest(url, this.headersmixins, params)
        if (res) {
            let projects: any = {}
            let settings: any = {}
            let companies: any = {}
            res.data.data.map((item: any) => {
                projects[item.id] = new JsonApiObject(item)
            })
            res.data.included.map((item: any) => {
                item.type == 'company' ? (companies[item.id] = item) : (settings[item.id] = item)
            })

            this.$store.commit('projects', { ...this.$store.getters.projects, ...projects })
            this.$store.commit('projectUserSettings', {
                ...this.$store.getters.projectUserSettings,
                ...settings,
            })
            this.$store.commit('projectCompanies', {
                ...this.$store.getters.projectCompanies,
                ...companies,
            })
        }

        return res.data.data
    }

    async searchProjects(params: any) {
        let url = `${this.url_project}/projects?include=userSettings,owner`
        let res = await getRequest(url, this.headersmixins, params)
        return res.data.data
    }

    async getProject(id: string, settingsMode = false) {
        let params =
            'include=owner,modules.project,hseContacts,hseDocuments.userSettings,userSettings'
        if (settingsMode) {
            params = this.projectSettingsFields + ',hseContacts,hseDocuments,userSettings&' + params
        }

        let url = `${this.url_project}/projects/${id}?${params}`
        let res = await getRequest(url, this.headersmixins)

        let project: any = { [res.data.data.id]: new JsonApiObject(res.data.data) }
        let companies: any = {}
        let modules: any = {}
        let hseContacts: any = {}
        let hseDocuments: any = {}
        let settings: any = {}
        let settingsJSON: any = {}
        let userSettings: any = {}

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'company':
                    companies[item.id] = item
                    break
                case 'projectModule':
                    modules[item.id] = item
                    break
                case 'hseContact':
                    hseContacts[item.id] = item
                    break
                case 'hseDocument':
                    hseDocuments[item.id] = item
                    break
                case 'projectUserSettings':
                    settings[item.id] = item
                    settingsJSON = item?.attributes?.frontEndSettings
                        ? JSON.parse(item.attributes.frontEndSettings)
                        : null
                    break
                case 'hseDocumentUserSettings':
                    userSettings[item.id] = item
                    break
            }
        })

        this.$store.commit('projects', project)
        this.$store.commit('projectCompanies', {
            ...this.$store.getters.projectCompanies,
            ...companies,
        })
        this.$store.commit('projectModules', modules)
        this.$store.commit('hseContacts', hseContacts)
        this.$store.commit('hseDocuments', hseDocuments)
        this.$store.commit('projectUserSettings', {
            ...this.$store.getters.projectUserSettings,
            ...settings,
        })
        this.$store.commit('hseDocumentsUserSettings', {
            ...this.$store.getters.hseDocumentsUserSettings,
            ...userSettings,
        })
        if (settingsJSON?.observationModule) {
            settingsJSON.observationModule.meMode
                ? this.$store.commit('meMode', settingsJSON.observationModule.meMode)
                : ''
            settingsJSON.observationModule.filter
                ? this.$store.commit('observationFilter', settingsJSON.observationModule.filter)
                : ''
            settingsJSON.observationModule.sort
                ? this.$store.commit('observationSort', settingsJSON.observationModule.sort)
                : ''
            settingsJSON.observationModule.layout
                ? this.$store.commit('observationLayout', settingsJSON.observationModule.layout)
                : ''
            settingsJSON.observationModule.columns
                ? this.$store.commit(
                      'observationColumnsArray',
                      settingsJSON.observationModule.columns
                  )
                : ''
        }
        return res.data.data
    }

    async postProject(data: any) {
        let url = `${this.url_project}/projects`
        let res = await postRequest(url, this.headersmixins, data)
        return res.data.data
    }

    async patchProject(params: any, settingsMode = false) {
        let query =
            'include=owner,modules.project,hseContacts,hseDocuments.userSettings,userSettings'
        if (settingsMode) {
            query = this.projectSettingsFields + ',hseContacts,hseDocuments,userSettings&' + query
        }

        let url = `${this.url_project}/projects/${params.data.id}?${query}`
        let res = await patchRequest(url, this.headersmixins, params.data)

        let project: any = { [res.data.data.id]: new JsonApiObject(res.data.data) }
        let companies: any = {}
        let modules: any = {}
        let hseContacts: any = {}
        let hseDocuments: any = {}
        let settings: any = {}
        let userSettings: any = {}

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'company':
                    companies[item.id] = item
                    break
                case 'projectModule':
                    modules[item.id] = item
                    break
                case 'hseContact':
                    hseContacts[item.id] = item
                    break
                case 'hseDocument':
                    hseDocuments[item.id] = item
                    break
                case 'projectUserSettings':
                    settings[item.id] = item
                    break
                case 'hseDocumentUserSettings':
                    userSettings[item.id] = item
                    break
            }
        })

        this.$store.commit('projects', project)
        this.$store.commit('projectCompanies', {
            ...this.$store.getters.projectCompanies,
            ...companies,
        })
        this.$store.commit('projectModules', { ...this.$store.getters.projectModules, ...modules })
        this.$store.commit('hseContacts', hseContacts)
        this.$store.commit('hseDocuments', hseDocuments)
        this.$store.commit('projectUserSettings', {
            ...this.$store.getters.projectUserSettings,
            ...settings,
        })
        this.$store.commit('hseDocumentsUserSettings', {
            ...this.$store.getters.hseDocumentsUserSettings,
            ...userSettings,
        })

        return res.data.data
    }

    // GROUP
    async getGroup(id: string) {
        let url = `${this.url_project}/projectGroups/${id}?include=owners,projects.owner,projects.modules.project,projects.hseContacts,projects.hseDocuments.userSettings,companies,sharedWith,userSettings`
        let res = await getRequest(url, this.headersmixins)

        let group: any = { [res.data.data.id]: res.data.data }
        let projects: any = {}
        let users: any = {}
        let companies: any = {}
        let modules: any = {}
        let hseContacts: any = {}
        let hseDocuments: any = {}
        let settings: any = {}
        let settingsJSON: any = {}
        let userSettings: any = {}

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'project':
                    projects[item.id] = new JsonApiObject(item)
                    break
                case 'user':
                    users[item.id] = item
                    break
                case 'company':
                    companies[item.id] = item
                    break
                case 'projectModule':
                    modules[item.id] = item
                    break
                case 'hseContact':
                    hseContacts[item.id] = item
                    break
                case 'hseDocument':
                    hseDocuments[item.id] = item
                    break
                case 'projectGroupUserSettings':
                    settings[item.id] = item
                    settingsJSON = item.attributes.frontEndSettings
                        ? JSON.parse(item.attributes.frontEndSettings)
                        : null
                    break
                case 'hseDocumentUserSettings':
                    userSettings[item.id] = item
                    break
            }
        })

        this.$store.commit('groups', group)
        this.$store.commit('projects', { ...this.$store.getters.projects, ...projects })
        this.$store.commit('projectModuleUsers', { ...this.$store.getters.projectUsers, ...users })
        this.$store.commit('projectCompanies', {
            ...this.$store.getters.projectCompanies,
            ...companies,
        })
        this.$store.commit('projectModules', modules)
        this.$store.commit('hseContacts', hseContacts)
        this.$store.commit('hseDocuments', hseDocuments)
        this.$store.commit('groupUserSettings', {
            ...this.$store.getters.groupUserSettings,
            ...settings,
        })
        this.$store.commit('hseDocumentsUserSettings', {
            ...this.$store.getters.hseDocumentsUserSettings,
            ...userSettings,
        })
        if (settingsJSON?.observationModule) {
            settingsJSON.observationModule.meMode
                ? this.$store.commit('meMode', settingsJSON.observationModule.meMode)
                : ''
            settingsJSON.observationModule.filter
                ? this.$store.commit('observationFilter', settingsJSON.observationModule.filter)
                : ''
            settingsJSON.observationModule.sort
                ? this.$store.commit('observationSort', settingsJSON.observationModule.sort)
                : ''
            settingsJSON.observationModule.layout
                ? this.$store.commit('observationLayout', settingsJSON.observationModule.layout)
                : ''
            settingsJSON.observationModule.columns
                ? this.$store.commit(
                      'observationColumnsArray',
                      settingsJSON.observationModule.columns
                  )
                : ''
        }
        return res.data.data
    }

    async postGroup(data: any) {
        let url = `${this.url_project}/projectGroups?include=userSettings,projects`
        let res = await postRequest(url, this.headersmixins, data)

        let groups: any = { [res.data.data.id]: res.data.data }
        let projects: any = {}
        let settings: any = {}

        res.data.included.map((item: any) => {
            item.type == 'project' ? (projects[item.id] = item) : (settings[item.id] = item)
        })

        this.$store.commit('groups', { ...this.$store.getters.groups, ...groups })
        this.$store.commit('projects', { ...this.$store.getters.projects, ...projects })
        this.$store.commit('groupUserSettings', {
            ...this.$store.getters.groupUserSettings,
            ...settings,
        })
        return res.data.data
    }

    async patchGroup(params: any) {
        let url = `${this.url_project}/projectGroups/${params.data.id}`
        let res = await patchRequest(url, this.headersmixins, params.data)
        let group = JSON.parse(JSON.stringify(this.$store.getters.group(this.$route.params.id)))
        group.attributes = res.data.data.attributes

        this.$store.commit('groups', { ...this.$store.getters.groups, ...{ [group.id]: group } })
        return res.data.data
    }

    async addProject(params: any) {
        let url = `${this.url_project}/projectGroups/${params.groupId}/relationships/projects/`
        let data = [
            {
                type: 'project',
                id: params.projectId,
            },
        ]

        let res = await postRequest(url, this.headersmixins, data)

        return res.data.data
    }

    async removeProject(params: any) {
        let url = `${this.url_project}/projectGroups/${params.groupId}/relationships/projects/`
        let data = [
            {
                type: 'project',
                id: params.projectId,
            },
        ]

        let res = await deleteRequest(url, this.headersmixins, data)

        return res.data.data
    }

    async deleteGroup(params: any) {
        let url = `${this.url_project}/projectGroups/${params.id}`
        let res = await deleteRequest(url, this.headersmixins)
        return res.data.data
    }

    // SETTINGS
    async patchProjectUserSettings(data: any) {
        let url = `${this.url_project}/projectUserSettings/${data.id}`
        let res = await patchRequest(url, this.headersmixins, data)
        let settings: any = { [res.data.data.id]: res.data.data }
        this.$store.commit('projectUserSettings', {
            ...this.$store.getters.projectUserSettings,
            ...settings,
        })
        return res.data.data
    }

    async patchtGroupUserSettings(data: any) {
        let url = `${this.url_project}/projectGroupUserSettings/${data.id}`
        let res = await patchRequest(url, this.headersmixins, data)
        let settings: any = { [res.data.data.id]: res.data.data }
        this.$store.commit('groupUserSettings', {
            ...this.$store.getters.groupUserSettings,
            ...settings,
        })
        return res.data.data
    }

    // LOCATIONS

    async getProjectLocations(groupId: string | null, projectId: string | null) {
        const { data } = await getRequest(
            getURL({
                path: `locations`,
                base: this.url_project,
                params: {
                    include: 'project,parent',
                    skipLinks: '',
                    ...(groupId && { 'filter[projectGroup]': groupId }),
                    ...(projectId && { 'filter[project]': projectId }),
                },
            })
        )

        const locations = deserialise(data).data
        this.$store.commit('projectLocations', locations)
        return locations
    }

    async getLocations(params: any) {
        let url = `${this.url_project}/locations`
        let res = await getRequest(url, this.headersmixins, params)
        let locations: any = {}
        res.data.data.map((item: any) => {
            locations[item.id] = item
        })
        this.$store.commit('projectLocations', {
            ...this.$store.getters.projectLocations,
            ...locations,
        })
        return res.data.data
    }

    async patchLocation(params: any) {
        let url = `${this.url_project}/locations/${params.data.id}`
        await patchRequest(url, this.headersmixins, params.data)
    }

    async postLocation(data: any) {
        let url = `${this.url_project}/locations`
        await postRequest(url, this.headersmixins, data)
    }

    // MODULES
    async getModules() {
        let url = `${this.url_project}/modules`
        let res = await getRequest(url, this.headersmixins)
        let modules: any = {}
        res.data.data.map((item: any) => {
            modules[item.id] = item
        })
        this.$store.commit('modules', { ...this.$store.getters.modules, ...modules })
    }

    async postProjectModule(data: any) {
        let url = `${this.url_project}/projectModules?include=project`
        let res = await postRequest(url, this.headersmixins, data)
        let modules = { [res.data.data.id]: res.data.data }
        this.$store.commit('projectModules', { ...this.$store.getters.projectModules, ...modules })
    }

    async patchProjectModule(params: any) {
        let url = `${this.url_project}/projectModules/${params.data.id}?include=project`
        let res = await patchRequest(url, this.headersmixins, params.data)
        let modules = { [res.data.data.id]: res.data.data }
        this.$store.commit('projectModules', { ...this.$store.getters.projectModules, ...modules })
    }

    // HSE CONTACTS
    async getHSEContacts(url: string) {
        let res = await getRequest(url, this.headersmixins)
        let hseContacts: any = {}
        res.data.data.map((item: any) => {
            hseContacts[item.id] = item
        })
        this.$store.commit('hseContacts', { ...this.$store.getters.hseContacts, ...hseContacts })
        return res.data.data
    }

    async postHSEContact(data: any) {
        let url = `${this.url_project}/hseContacts?include=project`
        let res = await postRequest(url, this.headersmixins, data)
        let contacts = { [res.data.data.id]: res.data.data }
        this.$store.commit('hseContacts', { ...this.$store.getters.hseContacts, ...contacts })
        return res.data.data
    }

    async patchHSEContact(params: { data: any; updatedAt: string }) {
        let url = `${this.url_project}/hseContacts/${params.data.id}?include=project`
        let res = await patchRequest(url, this.headersmixins, params.data)
        let contacts = { [res.data.data.id]: res.data.data }
        this.$store.commit('hseContacts', { ...this.$store.getters.hseContacts, ...contacts })
        return res.data.data
    }

    async deleteHSEContact(params: { id: string; updatedAt: string }) {
        let url = `${this.url_project}/hseContacts/${params.id}`
        await deleteRequest(url, this.headersmixins)
    }

    // HSE DOCUMENTS

    async postHSEDocument(data: any) {
        let url = `${this.url_project}/hseDocuments?include=project,userSettings`
        let res = await postRequest(url, this.headersmixins, data)

        let documents = { [res.data.data.id]: res.data.data }
        let userSettings: any = {}
        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'hseDocumentUserSettings':
                    userSettings[item.id] = item
                    break
            }
        })

        this.$store.commit('hseDocuments', { ...this.$store.getters.hseDocuments, ...documents })
        this.$store.commit('hseDocumentsUserSettings', {
            ...this.$store.getters.hseDocumentsUserSettings,
            ...userSettings,
        })

        return res.data.data
    }

    async patchHSEDocument(params: { data: any; updatedAt: string }) {
        let url = `${this.url_project}/hseDocuments/${params.data.id}?include=project,userSettings`
        let res = await patchRequest(url, this.headersmixins, params.data)

        let documents = { [res.data.data.id]: res.data.data }
        let userSettings: any = {}
        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'hseDocumentUserSettings':
                    userSettings[item.id] = item
                    break
            }
        })

        this.$store.commit('hseDocuments', { ...this.$store.getters.hseDocuments, ...documents })
        this.$store.commit('hseDocumentsUserSettings', {
            ...this.$store.getters.hseDocumentsUserSettings,
            ...userSettings,
        })

        return res.data.data
    }

    async deleteHSEDocument(params: { id: string; updatedAt: string }) {
        let url = `${this.url_project}/hseDocuments/${params.id}`
        await deleteRequest(url, this.headersmixins)
    }

    // HSE DOCUMENT USER SETTINGS
    async patchHSEDocumentUserSettings(params: any) {
        let url = `${this.url_project}/hseDocumentUserSettings/${params.id}`
        let res = await patchRequest(url, this.headersmixins, params)

        let userSettings: any = { [res.data.data.id]: res.data.data }

        this.$store.commit('hseDocumentsUserSettings', {
            ...this.$store.getters.hseDocumentsUserSettings,
            ...userSettings,
        })

        return res.data.data
    }

    // DASHBOARD
    async getDashboard(id: string) {
        const { data } = await getRequest(
            getURL({
                path: `dashboards/${id}`,
                base: this.url_project,
                params: {
                    include: 'project,projectGroup',
                    skipLinks: '',
                },
            }),
            {}
        )

        if (data) {
            const dashboard = deserialise(data).data
            this.$store.commit('dashboards', {
                ...this.$store.getters.dashboards,
                ...{ [dashboard.id]: dashboard },
            })
            return dashboard
        }
    }

    async getDashboards(filters: any) {
        const { data } = await getRequest(
            getURL({
                path: `dashboards`,
                base: this.url_project,
                params: {
                    include: 'project,projectGroup',
                    skipLinks: '',
                    ...filters,
                },
            }),
            {}
        )

        if (data) {
            let dashboardsArr: any = deserialise(data).data
            const dashboards = {}
            dashboardsArr.forEach((item: any) => {
                dashboards[item.id] = item
            })

            this.$store.commit('dashboards', { ...dashboards })
            return dashboardsArr
        }
    }

    async postDashboard(payload: any) {
        const { data } = await postRequest(
            getURL({
                path: `dashboards`,
                base: this.url_project,
                params: {
                    include: 'project,projectGroup',
                    skipLinks: '',
                },
            }),
            {},
            serialise('dashboard', payload).data
        )

        if (data) {
            const dashboard = deserialise(data).data
            this.$store.commit('dashboards', {
                ...this.$store.getters.dashboards,
                ...{ [dashboard.id]: dashboard },
            })
            return dashboard
        }
    }

    async patchDashboard(payload: any) {
        const { data } = await patchRequest(
            getURL({
                path: `dashboards/${payload.id}`,
                base: this.url_project,
                params: {
                    include: 'project,projectGroup',
                    skipLinks: '',
                },
            }),
            {},
            serialise('dashboard', payload).data
        )

        if (data) {
            const dashboard = deserialise(data).data
            this.$store.commit('dashboards', {
                ...this.$store.getters.dashboards,
                ...{ [dashboard.id]: dashboard },
            })
            return dashboard
        }
    }

    async publishDashboard(id: string) {
        const { data } = await postRequest(
            getURL({
                path: `dashboards/${id}/publish`,
                base: this.url_project,
                params: {
                    include: 'project,projectGroup',
                    skipLinks: '',
                },
            }),
            {}
        )

        if (data) {
            const dashboard = deserialise(data).data
            this.$store.commit('dashboards', {
                ...this.$store.getters.dashboards,
                ...{ [dashboard.id]: dashboard },
            })
            return dashboard
        }
    }

    async deleteDashboard(id: string) {
        const { data } = await deleteRequest(
            getURL({
                path: `dashboards/${id}`,
                base: this.url_project,
                params: {
                    include: 'project,projectGroup',
                    skipLinks: '',
                },
            }),
            {}
        )

        if (data) {
            let dashboards = JSON.parse(JSON.stringify(this.$store.getters.dashboards))
            delete dashboards[id]
            this.$store.commit('dashboards', dashboards)
            return dashboards
        }
    }

    get nextDashboard() {
        let id = null
        let dashboards: any = Object.values(this.$store.getters.dashboards)
        if (dashboards.length > 0) {
            let isDefault: any = dashboards.find((dashboard: any) => {
                return dashboard.isDefault
            })

            if (isDefault) {
                id = isDefault.id
            } else {
                id = dashboards[0].id
            }
        }

        return id
    }
}
